import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import MomentUtils from '@date-io/moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import style from './CreateAccount.module.scss';
import classes from '../Dialog.module.scss';

import NextStepButton from './NextStepButton';
import Button from '../../Button/Button';
import UserCard from './UserCard';
import Label from '../../InputLabel';
import Input from '../../Input/Input';
import AddEditSelectOptions from '../../../shared/AddEditSelectOptions'

const shirtOptions = [
  { id: 'XS', name: 'XS' },
  { id: 'S', name: 'S' },
  { id: 'M', name: 'M' },
  { id: 'L', name: 'L' },
  { id: 'XL', name: 'XL' },
  { id: 'XXL', name: 'XXL' },
]

const pantsOptions = [
  { id: '28', name: '28' },
  { id: '30', name: '30' },
  { id: '32', name: '32' },
  { id: '34', name: '34' },
  { id: '36', name: '36' },
  { id: '38', name: '38' },
  { id: '40', name: '40' },
]

const bootsOptions = [
  { id: '38', name: '38' },
  { id: '39', name: '39' },
  { id: '40', name: '40' },
  { id: '41', name: '41' },
  { id: '42', name: '42' },
  { id: '43', name: '43' },
  { id: '44', name: '44' },
  { id: '45', name: '45' },
  { id: '46', name: '46' },
]

const AdditionalData = ({
  user,
  handleInput,
  nextStep,
  previousStep,
  groups,
  places,
  skills,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={style.thirdForm}>
        <div className={classnames(style.info, style.borderRight)}>
          <UserCard user={user} groups={groups} places={places} skills={skills} />
        </div>
        <div className={style.form}>
          <div className={style.formItem}>
            <Label htmlFor='passport_number' text={t('Passport number')} />
            <Input
              name='passport_number'
              placeholder={t('Passport number')}
              value={user.passport_number ?? ''}
              onChange={handleInput}
              fullWidth
            />
          </div>

          <div className={style.formItem}>
            <Label htmlFor='passport_valid_date' text={t('Passport valid date')} />
            <div className={classes.dateInput}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  label={t('Passport valid date')}
                  value={user.passport_valid_date || null}
                  onChange={(date) => handleInput({
                    target: {
                      name: 'passport_valid_date',
                      value: date ? date.format('YYYY-MM-DD') : '',
                    },
                  })}
                  format='MMM, DD, YYYY'
                  name='passport_valid_date'
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>

          <div className={style.formItem}>
            <Label htmlFor='phone_number' text={t('Phone number')} />
            <Input
              name='phone_number'
              placeholder={t('Phone number')}
              value={user.phone_number ?? ''}
              onChange={handleInput}
              fullWidth
            />
          </div>

          <div className={style.formItem}>
            <Label htmlFor='birth_date' text={t('Birth date')} />
            <div className={classes.dateInput}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  label={t('Birth date')}
                  value={user.birth_date || null}
                  onChange={(date) => handleInput({
                    target: {
                      name: 'birth_date',
                      value: date ? date.format('YYYY-MM-DD') : '',
                    },
                  })}
                  format='MMM, DD, YYYY'
                  name='birth_date'
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>

          <div className={style.formItem}>
            <Label htmlFor='shirt_size' text={t('Shirt size')} />
            <AddEditSelectOptions
              id='shirt_size'
              options={shirtOptions}
              user={user}
              name='shirt_size'
              handleInput={handleInput}
              placeholder={t('Select a shirt size')}
            />
          </div>

          <div className={style.formItem}>
            <Label htmlFor='pants_size' text={t('Pants size')} />
            <AddEditSelectOptions
              id='pants_size'
              options={pantsOptions}
              user={user}
              name='pants_size'
              handleInput={handleInput}
              placeholder={t('Select a pants size')}
            />
          </div>

          <div className={style.formItem}>
            <Label htmlFor='boots_size' text={t('Boots size')} />
            <AddEditSelectOptions
              id='boots_size'
              options={bootsOptions}
              user={user}
              name='boots_size'
              handleInput={handleInput}
              placeholder={t('Select a boots size')}
            />
          </div>
          <div className={style.formItem}>
            <Label htmlFor='notes' text={t('Notes')} />
            <Input
              name='notes'
              placeholder={t('Notes')}
              value={user.notes ?? ''}
              onChange={handleInput}
              fullWidth
            />
          </div>
        </div>
      </div>

      <div className={style.buttons}>
        <Button
          onClick={() => {
            previousStep();
          }}
          size='big'
          cancel
        >
          {t('Back')}
        </Button>
        <NextStepButton
          className={style.nextButton}
          onClick={nextStep}
        />
      </div>
    </>
  );
};

export default AdditionalData;
